import { usePropertyContext } from '../context/PropertyContext/usePropertyContext';
export const useInternalPropertyValue = () => usePropertyContext().value;